import { apiGet, apiPost } from './api';

export async function verifyEmailToken(token: string): Promise<{ message: string; verified: boolean }> {
	return apiGet<{ message: string; verified: boolean }>(
		`/email-verification/verify?token=${encodeURIComponent(token)}`
	);
}

export async function resendVerificationEmail(userId: string): Promise<{ message: string; alreadyVerified?: boolean }> {
	return apiPost<{ message: string; alreadyVerified?: boolean }>('/email-verification/resend', {
		userId: Number(userId),
	});
}

